import { render, staticRenderFns } from "./CalendarListNew.vue?vue&type=template&id=5871395b&"
import script from "./CalendarListNew.vue?vue&type=script&lang=js&"
export * from "./CalendarListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5871395b')) {
      api.createRecord('5871395b', component.options)
    } else {
      api.reload('5871395b', component.options)
    }
    module.hot.accept("./CalendarListNew.vue?vue&type=template&id=5871395b&", function () {
      api.rerender('5871395b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListNew.vue"
export default component.exports